import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';
import { Constant } from 'src/app/common/constant/constant';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import * as moment from 'moment';

@Component({
  selector: 'app-repair-order-log',
  templateUrl: './repair-order-log.component.html',
  styleUrls: ['./repair-order-log.component.scss']
})
export class RepairOrderLogComponent implements OnInit {

  @Input() roId: any = 0;
  @Input() shortTitle: any = "RO";
  @Input() userId: any = 0;
  @Input() domainId: any = 0;
  @Input() innerHeight: any = 600;
  @Output() logEmit: EventEmitter<any> = new EventEmitter();

  public sconfig: PerfectScrollbarConfigInterface = {};
  public logData:any = [];
  public loading: boolean = true;

  constructor(
    private LandingpagewidgetsAPI: LandingpageService
  ) { }

  ngOnInit(): void {
    this.getLogInfo();
  }

  getLogInfo() {
    let apiInfo = {
      apikey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      roId: this.roId,
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiGetROActivityLogInfo(apiInfo).subscribe((response) => {
      console.log(response)
      let logData = response.data;
      logData.repairOrder.forEach(roLogItem => {
        let isAdminFlag = (roLogItem.isAdminInt == 1) ? true : false;
        roLogItem.isAdmin = isAdminFlag;
        if(roLogItem.dateStr !='0000-00-00 00:00:00'){
            let createdOn = moment.utc(roLogItem.dateStr).toDate(); 
            roLogItem.dateStr = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
          }
          else{
            roLogItem.dateStr = "-";
          }
      });
      logData.dispatch.forEach(dispatchLogItem => {
        let isAdminFlag = (dispatchLogItem.isAdminInt == 1) ? true : false;
        dispatchLogItem.isAdmin = isAdminFlag;
        if(dispatchLogItem.dateStr !='0000-00-00 00:00:00'){
            let createdOn = moment.utc(dispatchLogItem.dateStr).toDate(); 
            dispatchLogItem.dateStr = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
          }
          else{
            dispatchLogItem.dateStr = "-";
          }
      });
      this.logData = logData;
      this.loading = false;
    });
  }

}
